enum EPortalName {
    PLUS = 'PLUS',
    PLUSH = 'PLUSH',
    LOCALHOST = 'LOCALHOST',
}

export default EPortalName
